import { useEffect, useState } from 'react';
import { ZapIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
import { Countdown } from './Countdown';
import { trackInitiateCheckout } from './MetaPixel';
const CHECKOUT_URL = 'https://soldadura.impultienda.ar/checkout/soldadura';

/**
 * Sticky bottom bar that appears once the user scrolls past the hero CTA
 * (tracked via an element with id="hero-cta-anchor").
 */
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const anchor = document.getElementById('hero-cta-anchor');
    if (!anchor) return;
    const observer = new IntersectionObserver(([entry]) => {
      // Show the floating bar once the hero CTA has scrolled out of view.
      setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
    }, {
      threshold: 0
    });
    observer.observe(anchor);
    return () => observer.disconnect();
  }, []);
  return <AnimatePresence data-id="element-189" data-mp="14dn5s64y77bw">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 320,
      damping: 30
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-amber-500/40 bg-[#0d0d0f]/95 backdrop-blur px-3 py-2.5 shadow-[0_-8px_24px_rgba(0,0,0,0.5)]" data-id="element-190" data-mp="2b2740giwghwc">
          <div className="mx-auto flex max-w-md items-center gap-3" data-id="element-191" data-mp="1rdyb249j87vs">
            <div className="flex flex-col leading-tight" data-id="element-192" data-mp="1rgsv3uomvqoo">
              <span className="text-[10px] font-cond uppercase tracking-wider text-neutral-400" data-id="element-193" data-mp="1wec8ythf61g3">
                Oferta termina en
              </span>
              <span className="text-amber-400 text-base" data-id="element-194" data-mp="1ncuu1efr05sz">
                <Countdown variant="inline" data-id="element-195" data-mp="1nded4yh4x08l" />
              </span>
            </div>
            <a href={CHECKOUT_URL} onClick={() => trackInitiateCheckout()} className="flex flex-1 items-center justify-center gap-2 rounded-lg bg-amber-500 px-3 py-3 font-cond text-sm font-semibold uppercase tracking-wide text-[#0d0d0f] transition-colors hover:bg-amber-400 active:scale-[0.98]" data-id="element-196" data-mp="3ct44vgdrxqu5">
              <ZapIcon className="h-4 w-4 shrink-0 fill-[#0d0d0f]" data-id="element-197" data-mp="36bj3wlfo9ehw" />
              Quiero el sistema · $15
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}